import { useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { X } from "lucide-react";

import { useMilestones } from "@/lib/milestones";
import { track } from "@/lib/analytics";

interface MilestonePromptCardProps {
  milestoneKey: string;
  copy: string;
  linkTo?: string;
  linkLabel?: string;
}

export function MilestonePromptCard({
  milestoneKey,
  copy,
  linkTo,
  linkLabel,
}: MilestonePromptCardProps) {
  const { milestones, setMilestone, milestonesLoading } = useMilestones();

  useEffect(() => {
    track("onboarding_milestone_shown", { milestone_key: milestoneKey });
  }, [milestoneKey]);

  if (milestonesLoading) return null;
  if (milestones[milestoneKey] === true) return null;

  return (
    <div
      style={{
        borderLeft: "2px solid var(--caileve-gold)",
        backgroundColor: "rgba(198,166,107,0.06)",
        padding: "var(--caileve-space-5) var(--caileve-space-6)",
        marginBottom: "12px",
        position: "relative",
      }}
    >
      <p
        style={{
          fontFamily: "Cormorant Garamond, Georgia, serif",
          fontStyle: "italic",
          fontSize: 15,
          color: "var(--caileve-ink)",
          lineHeight: 1.6,
          paddingRight: "24px",
        }}
      >
        {copy}
      </p>

      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          style={{
            fontSize: 13,
            color: "var(--caileve-lilac)",
            fontStyle: "italic",
            fontFamily: "Cormorant Garamond, Georgia, serif",
          }}
        >
          {linkLabel}
        </Link>
      )}

      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => {
          setMilestone(milestoneKey, true);
          track("onboarding_milestone_dismissed", { milestone_key: milestoneKey });
        }}
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          background: "transparent",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <X className="h-3.5 w-3.5" color="var(--caileve-muted)" />
      </button>
    </div>
  );
}
